import { InvoiceStatus } from '../enums/invoiceStatus'
import type { QuoteStatus } from '../enums/quoteStatus'

export const isInvoiceStatus = (status: InvoiceStatus | QuoteStatus | undefined): status is InvoiceStatus => {
  return Object.values(InvoiceStatus).includes(status as InvoiceStatus)
}
